<div
  *ngIf="nrLoaderService.isLoading$ | async"
  class="nr-loader-container position-fixed w-100 h-100"
  aria-busy="true"
  aria-live="polite"
>
  <div
    class="spinner-border text-primary position-fixed top-50 start-0 end-0 m-auto nr-loader"
    role="status"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
